import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">

  <div className="footer-bottom">

    <div className="footer-copy">
      © 2026 Club Oficial RP. Todos los derechos reservados.
    </div>

    <div className="footer-center">
      Página Web Desarrollada por <span>AForge</span>
    </div>

    <div className="footer-links">
      <a href="/terminos">TÉRMINOS Y CONDICIONES</a>
      <a href="/privacidad">PRIVACIDAD</a>
      <a href="">🎮</a>
      <a href="">▶</a>
      <a href="">●</a>
    </div>

  </div>

</footer>
  );
};

export default Footer;